import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { CategoriesAutocomplete } from "@shared/components/AutocompleteFields";

export function ActivityForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("activity_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <CategoriesAutocomplete
          name="categories"
          label={translate("activity_admin.fields.categories")}
          multiple
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="image"
          label={translate("activity_admin.fields.image")}
          shape="square"
          size={150}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("activity_admin.fields.active")}
          defaultChecked={true}
          required
        />
      </Grid>
    </Grid>

  )
}
